import { render, staticRenderFns } from "./FeatureTable.vue?vue&type=template&id=83246c3c"
import script from "./FeatureTable.vue?vue&type=script&lang=js"
export * from "./FeatureTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports